export default function initPageTakeOverVideo() {
  const containers = document.querySelectorAll(".page_take_over_video");

  if (!containers.length) return;

  console.log("Page Take Over Video found, initializing...");

  containers.forEach((container) => {
    const overlay = container.querySelector(".video_overlay");
    const videoId = container.getAttribute("data-video-id");
    const playerContainer = container.querySelector("#youtube-player");

    if (!overlay || !videoId || !playerContainer) return;

    overlay.addEventListener("click", () => {
      console.log("Video overlay clicked, playing video:", videoId);

      // Add playing class to hide overlay via CSS
      container.classList.add("is-playing");

      // Inject YouTube iframe
      //autoplay=1 allows it to play immediately after load
      const iframe = document.createElement("iframe");
      iframe.setAttribute(
        "src",
        `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&showinfo=0&mute=0`,
      );
      iframe.setAttribute("allow", "autoplay; encrypted-media");
      iframe.setAttribute("allowfullscreen", "true");

      playerContainer.appendChild(iframe);
    });
  });
}
